// src/app/services/adpGage.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IJbox, IJboxParams, UpdatePayload } from '../models';

export const jboxApi = createApi({
  reducerPath: 'jboxApi',
  baseQuery,
  endpoints: (builder) => ({
    getJboxParams: builder.query<{ jbox: IJboxParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/jboxes/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getJbox: builder.query<IJbox, number>({
      query: (id) => `/api/v1.0/ahu/jboxes/${id}`,
      transformResponse: (data: IJbox) => {
        data.params = data.jbox_params ? JSON.parse(data.jbox_params) : {};
        return data;
      },
    }),
    getAllJboxesCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/jboxes/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getJboxesCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/jboxes/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    updateJbox: builder.mutation<IJbox, UpdatePayload<IJbox>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/jboxes/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
      transformResponse: (data: IJbox) => {
        data.params = data.jbox_params ? JSON.parse(data.jbox_params) : {};
        return data;
      },
    }),
  }),
});

export const {
  useLazyGetJboxQuery,
  useGetJboxParamsQuery,
  useGetAllJboxesCountQuery,
  useLazyGetJboxesCountQuery,
  useGetJboxQuery,
  useUpdateJboxMutation,
} = jboxApi;
